<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <h1>Alta de Productos Rappi</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="default" @click="$router.push('/rappi/item')">Crear Producto</b-button>
          <b-button variant="success" @click="sendMenuToRappi">Enviar Cambios</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page=1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
          stacked="sm"
            :filter="search"
            striped
            hover
            :items="productsTable"
            :fields="tableFields"
            responsive
            :per-page="byPage"
            :current-page="page"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button variant="warning" @click="$router.push('/rappi/item/' + data.item.id)"
                  >Editar</b-button
                >
              </b-button-group>
            </template>
            <template #cell(status)="data"> 
                <b-badge pill v-if="data.item.status" variant="success">ACTIVO</b-badge>
                <b-badge pill v-else-if="!data.item.status" variant="danger">INACTIVO</b-badge>    
            </template>
            <template #cell(imageUrl)="data"> 
              <img style="height: 100px;" :src="axios.defaults.baseURL + '/' +data.item.imageUrl">
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="page"
            :total-rows="productsTable.length"
            :per-page="byPage"
            aria-controls="my-table"
    ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "RappiProducts",
  components: { Nav },
  data() {
    return {
      byPage:20,
      page:1,
      productsTable: [],
      search: "",
      tableFields: [
        { key: "imageUrl", label: "Img" },
        { key: "id", label: "ID", sortable: true, sortDirection: "desc" , class:"align-middle"},
        { key: "sku", label: "SKU", sortable: true , class:"align-middle"},
        { key: "name", label: "Nombre" , sortable: true , class:"align-middle"},
        //{ key: "description", label: "Descripcion", sortable: true , class:"align-middle"},
        { key: "category.name", label: "Categoria", sortable: true , class:"align-middle"},
        { key: "price", label: "Precio", sortable: true , class:"align-middle"},
        { key: "status", label: "Status", sortable: true , class:"align-middle"},
        { key: "buttons", class:"align-middle", label:""},
      ],
    };
  },
  mounted() {
    this.getAllUsers();
  },
  methods: {   
    sendMenuToRappi(){
      let that = this;
      axios
        .post("/company/1/rappi/sendmenu")
        .then(function () {
          that.makeToast("Exito","Menu enviado a rappi","success")
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllUsers() {
      let that = this;
      axios
        .get("/rappi/menu/items")
        .then(function (response) {
          that.productsTable = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
